import { useState, useEffect } from '@wordpress/element'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper'

const api_content_element = document.getElementById('apis_content')
let api_content

if (api_content_element) {
    api_content = api_content_element.innerHTML
    api_content_element.remove()
}

const Apis = props => {
    const [apis, setApis] = useState([])
    const [searchText, setSearchText] = useState('')
    const [content, setContent] = useState('')
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        setLoader(true)
        setApis(fetched_apis)
        setLoader(false)
    }, [])

    useEffect(() => {
        setLoader(true)
        setContent(api_content)
        setLoader(false)
    }, [])

    return (
        <>
            <section className='api__wrap'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-3 api-controls__wrap">
                            <div className="api-controls desktop">
                                {apis.length > 0 && apis.map(
                                    api => {
                                        return (
                                            <div className='api-controls__group'>
                                                <a href={`#${api.anchor}`} className={`api-item-link api-item__title${api.hasSubtitles && ' has-subtitles'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#${api.anchor}`} aria-expanded="false" aria-controls="multiCollapseExample2">{api.title}</a>
                                                {api.hasSubtitles && <div className="api-controls__subtitles collapse multi-collapse" id={`${api.anchor}`}>
                                                    {api.subtitles.length > 0 && api.subtitles.map(
                                                        subtitle => {
                                                            if (subtitle.subtitle) {
                                                                return (
                                                                    <a href={`#${subtitle.anchor}`} className='api-item-link api-item__subtitle'>{subtitle.subtitle}</a>
                                                                )
                                                            }
                                                        }
                                                    )}
                                                </div>}
                                            </div>
                                        )
                                    }
                                )}
                            </div>
                            <div className="api-controls mobile">
                                <Swiper
                                    modules={[Navigation]}
                                    spaceBetween={5}
                                    slidesPerView={1}
                                    navigation
                                >
                                    {apis.length > 0 && apis.map(
                                        api => {
                                            return (
                                                <>
                                                    <SwiperSlide>
                                                    <a href={`#${api.anchor}`} className={`api-item__title${api.hasSubtitles && ' has-subtitles'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#${api.anchor}`} aria-expanded="false" aria-controls="multiCollapseExample2">{api.title}</a>
                                                    </SwiperSlide>
                                                    {api.hasSubtitles && api.subtitles.length > 0 && api.subtitles.map(
                                                        subtitle => {
                                                            if (subtitle.subtitle) {
                                                                return (
                                                                    <SwiperSlide>
                                                                        <a href={`#${subtitle.anchor}`} className='api-item__subtitle'>{subtitle.subtitle}</a>
                                                                    </SwiperSlide>
                                                                )
                                                            }
                                                        }
                                                    )}
                                                </>
                                            )
                                        }
                                    )}
                                </Swiper>
                            </div>
                            <a target='_blank' href="https://dev.midchains.com/sign-up/account-type" className='api-signup-link'>Sign Up to MidChains</a>
                        </div>
                        <div className="col-12 col-lg-9 api-content__wrap">
                            <div className="api-content" dangerouslySetInnerHTML={{ __html: content }}></div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Apis